'use strict';

var _ = require('lodash');
var StepSponsorshipController = function StepSponsorshipController($scope, configurationService, validationService, featureToggleService) {
  $scope.stepTitle = {
    'markets': 'Sponsor Market',
    'legs': 'Leg Entity'
  };
  $scope.isSummaryVisible = false;
  var isSposEnabled = featureToggleService.isEnabled('SPOS');
  var entities = $scope.isLegsWizard() ? _.cloneDeep(configurationService.getLegs()) : _.cloneDeep(configurationService.getPoses());
  if (featureToggleService.isEnabled('SEGMENT_CLASS_CONTROL')) {
    var markets = _.keyBy(configurationService.getMarkets(), function (m) {
      return m.origin + '-' + m.destination;
    });
  }
  function filterDirectForecastingMarkets(entity) {
    if (featureToggleService.isDisabled('DIRECT_FORECAST_ENABLE') || $scope.isLegsWizard()) {
      return true;
    }
    var marketData = _.find(configurationService.getMarkets(), {
      origin: entity.origin,
      destination: entity.destination
    });
    return _.get(marketData, 'forecastType', 'Market') === 'Market';
  }
  $scope.sponsoringMarkets = _.chain(entities).sortBy(['origin', 'destination']).filter(filterDirectForecastingMarkets).map(function (item) {
    var market = [item.origin, item.destination].join('-');
    if ($scope.isMarketsWizard()) {
      item.label = isSposEnabled ? market + ' (' + item.spos + ')' : market;
      item.id = market + ' (' + item.spos + ')';
      if (featureToggleService.isEnabled('SEGMENT_CLASS_CONTROL')) {
        item.isTrafficRestricted = _.get(markets, [market, 'isTrafficRestricted'], false);
      }
    } else {
      item.label = market;
      item.id = market;
    }
    return item;
  }).uniqBy('label').value();
  $scope.getUniquePos = function (significantPos) {
    return $scope.scheduleChange.getUniqSignificantPos(significantPos);
  };
  $scope.stepEntered = function (event, stepTitle) {
    if (stepTitle === $scope.stepTitle[$scope.wizardShown]) {
      $scope.isSummaryVisible = false;
    }
  };
  $scope.validate = function () {
    $scope.xtForm.submit();
    var invalid = $scope.xtForm.form.$invalid;
    $scope.isSummaryVisible = invalid;
    return !invalid;
  };
  validationService.registerValidator('StepSponsorship', $scope.validate);
  $scope.resetForm = function () {
    $scope.isSummaryVisible = false;
    $scope.xtForm.reset();
  };
};
StepSponsorshipController.$inject = ['$scope', 'ConfigurationService', 'ValidationService', 'FeatureToggleService'];
module.exports = StepSponsorshipController;